module.exports = __webpack_public_path__ + "static/media/user-alien.13f37816.svg";